import { render, staticRenderFns } from "./VuesticModal.vue?vue&type=template&id=5644852c"
import script from "./VuesticModal.vue?vue&type=script&lang=js"
export * from "./VuesticModal.vue?vue&type=script&lang=js"
import style0 from "./VuesticModal.vue?vue&type=style&index=0&id=5644852c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5644852c')) {
      api.createRecord('5644852c', component.options)
    } else {
      api.reload('5644852c', component.options)
    }
    module.hot.accept("./VuesticModal.vue?vue&type=template&id=5644852c", function () {
      api.rerender('5644852c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-modal/VuesticModal.vue"
export default component.exports